<script>
	import StepOption from "../Components/Steps/StepOption.svelte";
	import {clickForStepSettings} from "../static";
	import {External, M} from "../../external";

	export let add;
	export let parentPopup;
	export let order;
	export let length;
	export let automation;
	export let automationSave;

	let instance;

	let cmps = [];

	let stepOptions = [
		{type: "DELAY", message: M.AUTOMATED_ACTIONS},
		{type: "IF_ELSE", lastOnly: true},
		{type: "SPLIT", lastOnly: true},
		{type: "TARGET"},
		{type: "SEND_EMAIL", message: M.SENDING},
		{type: "SEND_EMAIL_NOTIFICATION"},
		...(window.messagingDisabled ? [] : [
			{type: "SEND_SMS"},
			{type: "SEND_WHATSAPP"},
			{type: "SEND_VOICE"},
		]),
		{type: "CONTACT_TAG_ADD", message: M.CONTACT},
		{type: "CONTACT_TAG_REMOVE"},
		{type: "CONTACT_PROPERTY_CHANGE"},
		{type: "CONTACT_LIST_ADD"},
		{type: "CONTACT_LIST_REMOVE"},
		{type: "CONTACT_LMS_ENROLL"},
		{type: "CONTACT_LMS_UNENROLL"},
		{type: "CONTACT_MEMBER_GROUP_ADD"},
		{type: "CONTACT_MEMBER_GROUP_REMOVE"},
		{type: "CONTACT_NOTE_ADD"},
		{type: "CONTACT_DELETE"},
		{type: "CONTACT_UNSUBSCRIBE"},
		{type: "START_AUTOMATION", message: M.OTHER},
		//  { type: "END_AUTOMATION" },
		{type: "TRIGGER_WEBHOOK"}
	];

	const onClick = (type) => {
		if (hasSettings(type)) {
			clickForStepSettings(type, null, add, null, parentPopup, order, automation, null, automationSave);
		} else {
			let step = {
				order: order,
				type: type
			};
			add(step);
			if (parentPopup) parentPopup.close();
			External.CPanel.setChanged(true);
		}
	};

	const hasSettings = (type) => {
		switch (type) {
			case "CONTACT_DELETE":
			case "CONTACT_UNSUBSCRIBE":
				return false;
		}
		return true;
	};

	$: cmps = cmps.filter((el) => el);
</script>

<div class="col20 f-left small-rules mb-25">
	<ul>
		{#each stepOptions as option, index (option)}
			{#if option.message}
				<li>
					<h4 class="col20 f-left mt-25 mb-10">{option.message}</h4>
				</li>
			{/if}
			{#if !option.lastOnly || length === order}
				<StepOption bind:this={cmps[index]} onClick={() => onClick(option.type)} bind:type={option.type}/>
			{/if}
		{/each}
	</ul>
</div>
